import CellName from "@/components/essay/table/cell_name.vue";

export default (flag) => ({
  name: "FlagUsedAiSuggestions",

  components: {
    CellName,
  },

  data: function () {
    return {
      flag,
    };
  },

  render: function (h) {
    return h("ul", [
      h("li", [
        "There is a ",
        h("b", `${this.flag.summary.aiUsageScore}%`),
        " likelihood this submission was written with AI assistance.",
      ]),
      h("li", [
        h("b", this.flag.summary.sentencesAffected),
        "% of the sentences show signs of AI assistance.",
      ]),
    ]);
  },
});
